<script setup lang="ts">
import { IconMinus, IconPlus } from '@tabler/icons-vue'
import { computed } from 'vue'

import BaseButton from '@tix/ds/components/atoms/BaseButton.vue'

interface Props {
  min: number
  max: number
}

const props = defineProps<Props>()

const model = defineModel<number>({ required: true })

const decrementDisabled = computed<boolean>(() => {
  return model.value <= props.min
})

const incrementDisabled = computed<boolean>(() => {
  return model.value >= props.max
})

function increment(): void {
  if (!incrementDisabled.value) {
    model.value = model.value + 1
  }
}

function decrement(): void {
  if (!decrementDisabled.value) {
    model.value = model.value - 1
  }
}
</script>

<template>
  <div class="quantity-picker">
    <BaseButton
      aria-label="Decrease quantity"
      class="decrement"
      :disabled="decrementDisabled"
      hierarchy="secondary"
      :iconAfter="IconMinus"
      intent="neutral"
      @click="decrement"
    />
    <div class="value">{{ model }}</div>
    <BaseButton
      aria-label="Increase quantity"
      class="increment"
      :disabled="incrementDisabled"
      hierarchy="secondary"
      :iconAfter="IconPlus"
      intent="neutral"
      @click="increment"
    />
  </div>
</template>

<style scoped>
.quantity-picker {
  display: inline-flex;
  align-items: center;
  gap: var(--space-0-75);
  background: var(--form-quantity-stepper-bg);
  border: var(--border-width) solid var(--form-quantity-stepper-border);
  border-radius: var(--radius-medium);
  padding: var(--space-0-5);
  align-self: flex-start;

  button {
    --button-secondary-border-radius: var(--radius-medium);
    width: var(--space-3);
    height: var(--space-3);
  }

  .value {
    width: 20px;
    text-align: center;
  }
}
</style>
